export const zhCN = {
  'common.save': '保存',
  'common.cancel': '取消',
  'common.edit': '编辑',
  'common.loading': '加载中…',
  'common.error.load': '加载失败',
  'common.logout': '退出登录',
  'common.language': '界面语言',
  'common.zh': '中文',
  'common.en': 'English',
  'nav.home': '工作台',
  'nav.library': '料理库',
  'nav.menus': '菜单',
  'nav.ingredients': '原料库',
  'nav.imports': '导入配方',
  'nav.scaling': '配方换算',
  'nav.more': '更多',
  'nav.members': '成员',
  'nav.roles': '权限组',
  'nav.audit': '操作记录',
  'nav.account': '账号与安全',
  'auth.login': '登录',
  'auth.loggingIn': '登录中…',
  'auth.email': '邮箱',
  'auth.password': '密码',
  'auth.loginFailed': '登录失败',
  'auth.forgot': '忘记密码？请联系管理员重置。',
  'auth.title': '登录',
  'auth.subtitle': '继续管理配方、菜单和研发记录。',
  'account.title': '账号与安全',
  'account.subtitle': '管理显示名称、界面语言与登录密码。',
  'account.profile': '个人资料',
  'account.displayName': '显示名称',
  'account.saveProfile': '保存资料',
  'account.profileSaved': '个人资料已保存。',
  'account.passwordTitle': '修改密码',
  'account.currentPassword': '当前密码',
  'account.newPassword': '新密码',
  'account.confirmPassword': '确认新密码',
  'account.changePassword': '修改密码',
  'account.passwordChanged': '密码已修改，其他设备的登录会话已撤销。',
  'account.passwordHelp': '密码至少 12 位。修改后当前设备继续登录，其他设备需要重新登录。',
  'account.forcedTitle': '请先更换临时密码',
  'account.forcedBody': '管理员为你设置了临时密码。请先修改密码再继续。',
  'account.forcedDone': '密码已更新，可以继续使用。',
  'members.title': '成员与权限组',
  'members.subtitle': '成员离开当前空间时，停用这个空间里的访问即可。历史记录会保留，也不会影响该账号在其他空间的使用。',
  'members.add': '添加成员',
  'members.collapse': '收起',
  'members.name': '名称',
  'members.email': '邮箱',
  'members.tempPassword': '临时密码',
  'members.tempPasswordHelp': '成员首次登录后必须立即修改。',
  'members.create': '创建成员',
  'members.active': '启用',
  'members.disabled': '当前空间已停用',
  'members.disable': '停用当前空间访问',
  'members.enable': '重新启用',
  'members.protected': '仅主管理员可管理',
  'members.mustChange': '需改密',
  'members.resetPassword': '重置密码',
  'members.resetTitle': '设置临时密码',
  'members.resetHelp': '保存后，该成员会从所有设备退出，下次登录必须先修改密码。如果这个账号同时属于多个空间，需要由主管理员处理。',
  'members.resetDone': '临时密码已设置，成员的登录会话已撤销。',
  'members.createFailed': '创建失败',
  'members.saveFailed': '保存失败',
  'home.kicker': '工作台',
  'home.title': '继续工作',
  'home.subtitle': '从配方、菜单或换算开始。',
  'home.access': '当前账号',
  'audit.empty': '还没有操作记录。',
  'audit.subtitle': '这里记录谁在什么时候做了什么。记录只追加，不会被改写。'
} as const;

export type TranslationKey = keyof typeof zhCN;
